// extracted by mini-css-extract-plugin
module.exports = {"container":"container___1G78_"};